module.exports = __webpack_public_path__ + "static/media/logo.64c07598.png";